import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { PropsWithChildren, useEffect } from 'react';
import { DEFAULT_FILTERS_PAGE_URL, TENANT_LOGIN_PAGE_URL } from '../../constants/appUrls';
import { redirectTo } from '../../utils/routeHelper';

/**
 * If the user is on the tenant login page (/login-page) and is authenticated, redirect them to the default filters page (/filters).
 */
function LoginPageAuthenticationController({ children }: PropsWithChildren) {
    const {
        pathname,
        query: { callBackUrl }
    } = useRouter();
    const { status } = useSession();
    useEffect(() => {
        pathname === '/login-page' &&
            status === 'authenticated' &&
            redirectTo(callBackUrl?.toString() || DEFAULT_FILTERS_PAGE_URL);
    }, [callBackUrl, pathname, status]);

    return <>{children}</>;
}

export default function PublicPage({ children }: PropsWithChildren) {
    const { pathname } = useRouter();

    if (pathname === TENANT_LOGIN_PAGE_URL)
        return <LoginPageAuthenticationController>{children}</LoginPageAuthenticationController>;

    return <>{children}</>;
}
